export default __webpack_public_path__ + "static/media/bg-4.e5a07b68.jpg";